
import api from "@/services/api"
import { CaseNameSettings } from "@/types/caseNameSettings"

class ApiCaseNameSettings {
	private get axios () { return api.getAxios() }

	public async caseNameSettingsList (): Promise<CaseNameSettings[]> { return (await this.axios.get("/caseNameSettings")).data }
	public async caseNameSettingsSave (caseNameSettings: CaseNameSettings): Promise<string> { return (await this.axios.post("/caseNameSettings", caseNameSettings)).data }
	public async caseNameSettingsDelete (caseNameSettings: CaseNameSettings): Promise<void> { await this.axios.delete(`/caseNameSettings/${caseNameSettings.id}`) }
	public async caseNameSettingsDefault (caseNameSettings: CaseNameSettings): Promise<void> { await this.axios.put(`/caseNameSettings/default/${caseNameSettings.id}`) }
}

const apiCaseNameSettings = new ApiCaseNameSettings()
export default apiCaseNameSettings
